import { Stack } from 'src/core/ui';
import * as Tabs from 'src/core/ui/Tabs';

import * as styles from '../EventPage.css';

export enum SidePanelTab {
  LISTINGS = 'listings',
  SALES = 'sales',
  NOTES = 'notes',
  PURCHASES = 'purchases',
  INVENTORY = 'inventory',
  B2B = 'b2b',
}

const HeaderTabs = ({
  tabs,
}: {
  tabs: (
    | {
        label: JSX.Element;
        value: SidePanelTab;
        content: JSX.Element;
      }
    | {
        label: JSX.Element;
        value: SidePanelTab;
        content?: undefined;
      }
  )[];
}) => {
  return (
    <Tabs.List>
      {tabs.map((tab) => (
        <Tabs.Trigger key={tab.value} value={tab.value}>
          {tab.label}
        </Tabs.Trigger>
      ))}
    </Tabs.List>
  );
};

type SidePanelHeaderProps = {
  tabs: (
    | {
        label: JSX.Element;
        value: SidePanelTab;
        content: JSX.Element;
      }
    | {
        label: JSX.Element;
        value: SidePanelTab;
        content?: undefined;
      }
  )[];
};

export const SidePanelHeader: React.FC<SidePanelHeaderProps> = ({ tabs }) => {
  return (
    <Stack direction="column" gap="l">
      <div className={styles.pricingModelHeader}>
        <HeaderTabs tabs={tabs} />
      </div>
    </Stack>
  );
};
